import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { removeFavorite } from '../../actions/favoriteEntities';
import { ResultsMobile } from '../../components/ResultsMobile';
import { PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { selectActiveTab } from '../../selectors/activeTab';
import { isFavoritesForAuthorizationEnabled } from '../../selectors/experiments/isFavoritesForAuthorizationEnabled';
import { ETabType } from '../../types/filters';
import { IApplicationState } from '../../types/redux';
import { EGetFavoriteEntitiesStatus } from '../../types/results';
import { SavedSearches } from '../SavedSearches';

interface IResultsMobileContainer {
  isExperimentEnabled?: boolean;
}

export const ResultsMobileContainer: React.FC<IResultsMobileContainer> = ({ isExperimentEnabled }) => {
  const results = useSelector((state: IApplicationState) => state.results);
  const page = useSelector((state: IApplicationState) => state.page);
  const favoritesForAuthorizationEnabled = useSelector(isFavoritesForAuthorizationEnabled);
  const { activeTab } = useSelector(selectActiveTab);

  const dispatch = useDispatch();

  const handleClick = React.useCallback(
    (entityId: number) => {
      dispatch(removeFavorite({ entityId }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [dispatch],
  );

  React.useEffect(() => {
    if (favoritesForAuthorizationEnabled) {
      dispatch(requestAuthentication());
    }
  }, [dispatch, favoritesForAuthorizationEnabled]);

  if (results.status === EGetFavoriteEntitiesStatus.Failed) {
    return null;
  }

  //если выбран таб "Поиски"
  if (activeTab === ETabType.SavedSearches) {
    return (
      <Experiment name={PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT} group="B">
        <SavedSearches />
      </Experiment>
    );
  }

  return (
    <ResultsMobile
      results={results}
      page={page}
      isFavoritesForAuthorizationEnabled={favoritesForAuthorizationEnabled}
      removeFavorite={handleClick}
      isExperimentEnabled={isExperimentEnabled}
    />
  );
};
